<template>
  <ul
    class="sidebar-menu"
    v-if="authService.currentRole.nama_role === 'Operator Desa'"
  >
    <router-link
      to="/operator-desa"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-home" /><span>Home</span></a>
    </router-link>
    <router-link
      to="/profil-desa"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-home" /><span>Profil Desa</span></a>
    </router-link>
    <li class="menu-header">
      Layanan
    </li>
    <router-link
      to="/info-layanan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="far fa-list-alt" /><span>Layanan</span></a>
    </router-link>
    <li class="menu-header">
      Permohonan
    </li>
    <router-link
      to="/permohonan/buat-permohonan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-user-plus" /><span>Buat Permohonan</span></a>
    </router-link>
    <router-link
      to="/permohonan/data-permohonan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-list-alt" /><span>Data Permohonan</span></a>
    </router-link>
    <router-link
      to="/permohonan/riwayat-input"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-calendar" /><span>Riwayat Input</span></a>
    </router-link>
    <li class="menu-header">
      Laporan
    </li>
    <router-link
      to="/report/jumlah-permohonan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-columns" /><span>Jumlah Permohonan</span></a>
    </router-link>
    <router-link
      to="/report/status-permohonan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-columns" /><span>Status Permohonan</span></a>
    </router-link>
    <li class="menu-header">
      Kependudukan
    </li>
    <router-link
      to="/kependudukan/akun-penduduk"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-user" /><span>Kelola Akun</span></a>
    </router-link>
    <router-link
      to="/kependudukan/generate-otp"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-user" /><span>Generate OTP</span></a>
    </router-link>
  </ul>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	computed: {
		authService(){
			return this.$store.getters.getAuthService
		}
	},
	created(){

	}
}
</script>